import angular from "angular";
import {ScoreDateRangeSelector} from "./dates/ScoreDateRangeSelector";
import ScoreWidget from "./widget/ScoreWidget"


const mod = angular.module('clientDashboardApp.socialScore', []);

export default mod;

mod.value("ScoreDateRangeSelector", ScoreDateRangeSelector)
mod.value("ScoreWidget", ScoreWidget)




